import { NSARouterMakerResult } from 'namirasoft-account-react';
import { AlarmInputRow, AlarmLimitPerUnit, AlarmRow, ProductRow } from 'namirasoft-alarm';
import { BaseMetaColumn, FilterItem, FilterItemColumnType, NamingConvention, SortItem } from 'namirasoft-core';
import { TopicRow } from 'namirasoft-notification-sender';
import { NamirasoftMap } from 'namirasoft-site-map';
import { NSBox, NSBoxBoolean, NSBoxCombo, NSBoxEntity, NSBoxEnum, NSBoxInteger, NSBoxString, NSBoxTextArea, NSColumn, NSFilterBox, NSRow } from "namirasoft-site-react";
import { Component, createRef } from 'react';
import { AlarmEntities } from '../AlarmEntities';
import { AlarmLayout } from '../AlarmLayout';
import { AlarmProps } from '../AlarmProps';

export interface AlarmEditPageProps extends NSARouterMakerResult, AlarmProps
{
	isEdit: boolean;
}

interface AlarmEditPageState
{
	product: ProductRow | null;
	entity: string | null;
	action: string | null;
}

export default class AlarmEditPage extends Component<AlarmEditPageProps, AlarmEditPageState>
{
	private NSBoxString_Name = createRef<NSBoxString>();
	private NSBoxEntity_Topic = createRef<NSBoxEntity<TopicRow>>();
	private NSBoxEntity_Product = createRef<NSBoxEntity<ProductRow>>();
	private NSBoxCombo_Entity = createRef<NSBoxCombo>();
	private NSBoxCombo_Action = createRef<NSBoxCombo>();
	private NSBoxTextArea_Description = createRef<NSBoxTextArea>();
	private NSFilterBox_Filter = createRef<NSFilterBox>();
	private NSBoxBoolean_Limit = createRef<NSBoxBoolean>();
	private NSBoxInteger_Limit_Count = createRef<NSBoxInteger>();
	private NSBoxInteger_Limit_Per_Value = createRef<NSBoxInteger>();
	private NSBoxEnum_Limit_Per_Unit = createRef<NSBoxEnum<AlarmLimitPerUnit>>();

	constructor(props: AlarmEditPageProps)
	{
		super(props);
		this.state = {
			product: null,
			entity: null,
			action: null
		};
		this.onChangeProduct = this.onChangeProduct.bind(this);
		this.onChangeEntity = this.onChangeEntity.bind(this);
		this.onChangeAction = this.onChangeAction.bind(this);
	}
	private onChangeProduct(e: NSBoxEntity<ProductRow>, callback?: () => void) 
	{
		let product = e.getDataOne();
		this.setState({ product, entity: null }, () =>
		{
			this.NSBoxCombo_Entity.current?.setValue(null, () =>
			{
				this.NSBoxCombo_Entity.current?.reload();
			})
			callback?.();
		});
	}
	private onChangeEntity(e: NSBoxCombo, callback?: () => void)
	{
		let entity = e.getValueOne(false);
		if (entity !== null)
			this.setState({ entity }, () =>
			{
				this.NSBoxCombo_Action.current?.setValue(null, () =>
				{
					this.NSBoxCombo_Action.current?.reload();
				})
				this.NSFilterBox_Filter.current?.reloadTables();
				callback?.();
			});
	}
	private onChangeAction(e: NSBoxCombo, callback?: () => void)
	{
		let action = e.getValueOne(false);
		if (action !== null)
			this.setState({ action }, callback);
	}
	override render()
	{
		let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);

		let extra_tabs = [];
		extra_tabs.push({
			title: "Filters",
			clicked: true,
			getContent: () =>
			{
				return <div
					style={{ width: NSBox.width.double, maxWidth: NSBox.width.double, minHeight: "600px" }}>
					{
						this.state.entity &&
						<NSRow>
							<NSFilterBox
								ref={this.NSFilterBox_Filter}
								getTables={() =>
								{
									let product = this.NSBoxEntity_Product.current?.getDataOne() ?? null;
									let entity: string = this.NSBoxCombo_Entity.current?.getValueOne() ?? "";
									entity = NamingConvention.auto.convert(entity, NamingConvention.lower_case_underscore)
									if (product)
										if (entity)
										{
											let columns: {
												[name: string]: BaseMetaColumn;
											} = {};
											try
											{
												let namirasoft = new NamirasoftMap();
												let table = namirasoft.getByProductID(product.id);
												columns = table.tables[entity].columns;
											} catch (error)
											{
											}
											return [{
												name: entity,
												text: NamingConvention.auto.convert(entity, NamingConvention.Pascal_Case_Space),
												columns: Object.keys(columns).map(column =>
												{
													return {
														id: columns[column].name,
														name: columns[column].name,
														text: columns[column].text,
														type: columns[column].type as FilterItemColumnType,
													}
												}),
												required: false,
												getValues: async () => []
											}];
										}
									return [];
								}}
								getMoreTables={async () => []}
								getValues={null}
							/>
						</NSRow>
					}
				</div>
			},
		});
		extra_tabs.push(
			{
				title: "Limit",
				clicked: true,
				getContent: () =>
				{
					return (
						<NSColumn style={{ width: NSBox.width.double }}>
							<NSRow>
								<NSBoxBoolean
									ref={this.NSBoxBoolean_Limit}
									title="Limit"
									required
									style={{ width: "100%" }}
									defaultValue={false}
									onChanged={() => this.setState({})}
									info={{ link: "https://namirasoft.com/alarm/console-guide/alarm/#field-limit" }}
								/>
							</NSRow>
							<NSRow style={this.NSBoxBoolean_Limit.current?.getValueBool() ? {} : { display: "none" }}>
								<NSBoxInteger
									ref={this.NSBoxInteger_Limit_Count}
									title="Limit Count"
									required
									min={0}
									info={{ link: "https://namirasoft.com/alarm/console-guide/alarm/#field-limit-count" }}
									style={{ width: "100%" }}
								/>
							</NSRow>
							<NSRow style={this.NSBoxBoolean_Limit.current?.getValueBool() ? {} : { display: "none" }}>
								<NSBoxInteger
									ref={this.NSBoxInteger_Limit_Per_Value}
									title="Limit Per Value"
									required
									min={1}
									info={{ link: "https://namirasoft.com/alarm/console-guide/alarm/#field-limit-per-value" }}
								/>
								<NSBoxEnum<AlarmLimitPerUnit>
									ref={this.NSBoxEnum_Limit_Per_Unit}
									title="Limit Per Unit"
									required
									multiple={false}
									getEnumObject={() => AlarmLimitPerUnit}
									info={{ link: "https://namirasoft.com/alarm/console-guide/alarm/#field-limit-per-unit" }}
								/>
							</NSRow>
						</NSColumn>
					);
				}
			}
		);

		return (
			<AlarmLayout<AlarmRow, AlarmInputRow>
				action={{
					title: "",
					description: `${this.props.isEdit ? "Add a new alarm based on your preferences to receive notifications about relevant activities." : ""}`,
					menus: {}
				}}
				{...this.props}
				pages={{
					entity: AlarmEntities.alarm(this.props),
					edit: {
						...this.props,
						ui: {
							tab_page_edit: {
								editor: {
									getInputRow: () =>
									{
										let name: string = this.NSBoxString_Name.current?.getValue() ?? "";
										let topic_id: string = this.NSBoxEntity_Topic.current?.getValueOne() ?? "";
										let product_id: string = this.NSBoxEntity_Product.current?.getValueOne() ?? "";
										let entity: string = this.NSBoxCombo_Entity.current?.getValueOne() ?? "";
										let action: string = this.NSBoxCombo_Action.current?.getValueOne() ?? "";
										let filters: FilterItem[] = this.NSFilterBox_Filter.current?.getFilterItems() ?? [];
										let description: string = this.NSBoxTextArea_Description.current?.getValue() ?? "";

										let aggregation = false; // todo implement
										let aggregation_interval_value = null; // todo implement
										let aggregation_interval_unit = null; // todo implement
										let aggregation_function = null; // todo implement
										let aggregation_column = null; // todo implement
										let aggregation_operator = null; // todo implement
										let aggregation_value = null; // todo 

										// Limit
										let limit: boolean = this.NSBoxBoolean_Limit.current?.getValueBool() ?? false;
										let limit_count: number | null = null;
										let limit_per_value: number | null = null;
										let limit_per_unit: AlarmLimitPerUnit | null = null;
										if (limit)
										{
											limit_count = this.NSBoxInteger_Limit_Count.current?.getValue() ?? 0;
											limit_per_value = this.NSBoxInteger_Limit_Per_Value.current?.getValue() ?? 0;
											limit_per_unit = this.NSBoxEnum_Limit_Per_Unit.current?.getValueEnumOne(AlarmLimitPerUnit, AlarmLimitPerUnit.Second) ?? AlarmLimitPerUnit.Second;
										}

										entity = NamingConvention.auto.convert(entity, NamingConvention.lower_case_underscore);
										action = NamingConvention.auto.convert(action, NamingConvention.lower_case_underscore);

										return {
											workspace_id: "",
											product_id,
											topic_id,
											name,
											entity,
											action,
											filters: FilterItem.stringify(filters),
											description,
											aggregation,
											aggregation_interval_value,
											aggregation_interval_unit,
											aggregation_function,
											aggregation_column,
											aggregation_operator,
											aggregation_value,
											limit,
											limit_count,
											limit_per_value,
											limit_per_unit,
											alarm_category: [], alarm_field: [], alarm_tag: []
										};
									},
									setRow: (row) =>
									{
										this.NSBoxString_Name.current?.setValue(row.name);
										this.NSBoxEntity_Topic.current?.setValue(row.topic_id)
										this.NSBoxEntity_Product.current?.setValue(row.product_id, () =>
										{
											this.NSBoxCombo_Entity.current?.setValue(row.entity, () =>
											{
												if (this.NSBoxCombo_Entity.current)
													this.onChangeEntity(this.NSBoxCombo_Entity.current, () =>
													{
														this.NSBoxCombo_Action.current?.setValue(row.action ?? "", () =>
														{
															if (this.NSBoxCombo_Action.current)
																this.onChangeAction(this.NSBoxCombo_Action.current, () =>
																{
																	this.NSBoxTextArea_Description.current?.setValue(row.description ?? "");
																	this.NSFilterBox_Filter.current?.setFilterItems(FilterItem.parse(row.filters ?? ""));
																});
														});
													});
											});
										});
										this.NSBoxBoolean_Limit.current?.setValue(row.limit);
										if (row.limit)
										{
											this.NSBoxInteger_Limit_Count.current?.setValue(row.limit_count);
											this.NSBoxInteger_Limit_Per_Value.current?.setValue(row.limit_per_value);
											this.NSBoxEnum_Limit_Per_Unit.current?.setValue(row.limit_per_unit);
										}
									}
								},
								ui: {
									extra_tabs
								}
							}
						},
					}
				}}
			>
				<NSColumn>
					<NSBoxString
						ref={this.NSBoxString_Name}
						title="Name"
						required
						style={{ width: "100%" }}
						info={{ link: "https://namirasoft.com/alarm/console-guide/alarm/#field-name" }}
					/>
					<NSRow>
						<NSBoxEntity<TopicRow>
							ref={this.NSBoxEntity_Topic}
							title="Topic"
							required
							table={namirasoft.notification_sender.tables.topic}
							getTitle={(item) => item.name}
							getValue={item => item.id}
							multiple={false}
							getSort={() => null}
							info={{ link: "https://namirasoft.com/alarm/console-guide/alarm/#field-topic" }}
						/>
						<NSBoxEntity<ProductRow>
							ref={this.NSBoxEntity_Product}
							title="Product"
							multiple={false}
							listable={false}
							viewable={false}
							required
							table={namirasoft.alarm.tables.product}
							getValue={item => item.id}
							getTitle={item => item.name}
							onChanged={this.onChangeProduct}
							getSort={() =>
							{
								let namirasoft = new NamirasoftMap();
								let table = namirasoft.alarm.tables.product;
								let column = table.columns.name;
								return new SortItem(table, column, true);
							}}
							info={{ link: "https://namirasoft.com/alarm/console-guide/alarm/#field-product" }}
						/>
					</NSRow>
					<NSRow>
						<NSBoxCombo
							ref={this.NSBoxCombo_Entity}
							required
							title="Entity"
							multiple={false}
							getOptions={() =>
							{
								let entities: string[] = AlarmEntities.getEntities(this.state.product);
								return entities.map(entity => ({
									value: `${NamingConvention.auto.convert(entity, NamingConvention.lower_case_underscore)}`,
									title: `${NamingConvention.auto.convert(entity, NamingConvention.Pascal_Case_Space)}`
								}))
							}}
							onChanged={this.onChangeEntity}
							info={{ link: "https://namirasoft.com/alarm/console-guide/alarm/#field-entity" }}
						/>
						<NSBoxCombo
							ref={this.NSBoxCombo_Action}
							required
							title="Action"
							multiple={false}
							getOptions={() =>
							{
								let actions: string[] = AlarmEntities.getActions(this.state.product, this.state.entity);
								return actions.map(action => ({
									value: `${action}`,
									title: `${NamingConvention.auto.convert(action, NamingConvention.Pascal_Case_Space)}`
								}))
							}}
							onChanged={this.onChangeAction}
							info={{ link: "https://namirasoft.com/alarm/console-guide/alarm/#field-action" }}
						/>
					</NSRow>
					<NSBoxTextArea
						ref={this.NSBoxTextArea_Description}
						title="Description"
						required={false}
						info={{ link: "https://namirasoft.com/alarm/console-guide/alarm/#field-description" }}
						style={{ width: "100%" }}
					/>
				</NSColumn>
			</AlarmLayout>
		);
	}
}